import { Grid as Grid_ } from './grid';
import { Stack as Stack_ } from './stack';

export namespace Matrix {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  export import Grid = Grid_;
  export import Stack = Stack_;
}
